import { Component, ViewContainerRef} from '@angular/core';
import { SystemSettingService } from '../../services/system-settings/system-setting.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
import { ReportService } from '../../services/report/report.service';
import { SelectList } from '../../models/shared/shared.model';
import { SalesFilter, ReportSale } from '../../models/report/sale.model';
 
@Component({
  selector: 'rpt-shipment',
  templateUrl: './rpt-shipment.component.html',
  styleUrls: ['./rpt-shipment.component.css']
})

export class RptShipmentComponent {
  public stores: SelectList[] = [];
  public shippingMethods: SelectList[] = [];
  public statuses: SelectList[] = [];
  public saleFilter: SalesFilter = new SalesFilter();
  public reportSale: ReportSale[] = [];
  public isDeleteAllowed: boolean = false;
  public isEditSimpleAllowed: boolean = false;
  public isEditVariableAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  public filterStatus: string = "All";
  public filterShiping: string = "All";
  public filterDate: string = "N/A";
  public totalOrderPrice: number;
  public totalShippingPrice: number;
  constructor(private readonly SystemSettingService: SystemSettingService,
    private readonly reportService: ReportService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private readonly router: Router, private utilityService: UtilitiesService) {
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.preBind();
    this.saleFilter.StoreId = 0;
    this.saleFilter.StatusId = 0;
    this.saleFilter.ShippingId = 0;
  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("product").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "editsimple");
          });
          var editVariable = data.filter(function (element) {
            return (element.action == "editvariable");
          });
          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditSimpleAllowed = true;
          if (editVariable.length > 0)
            this.isEditVariableAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  preBind() {
    this.reportService.ShipmentReportPreBind().subscribe(
      d => {
        if (d.success) { 
          this.shippingMethods = d.data.shippingMethods;
          this.statuses = d.data.statuses;
        }
        else
          this.toastr.error(d.message);

      }
    )
  }
  generateReport(isPrint: boolean, btnT: any) {
    if (this.saleFilter.StatusId != 0)
      this.filterStatus = this.statuses.find(x => x.id == String(this.saleFilter.StatusId)).name;
    else
      this.filterStatus = "All";

    if (this.saleFilter.ShippingId != 0)
      this.filterShiping = this.shippingMethods.find(x => x.id == String(this.saleFilter.ShippingId)).name;
    else
      this.filterShiping = "All";
 
    var currentTarget = btnT.currentTarget;
    this.utilityService.toggleButtonAnimation(currentTarget)
    this.reportService.ShipmentReportFetch(this.saleFilter).subscribe(
      d => {
        this.utilityService.toggleButtonAnimation(currentTarget);
        if (d.success) {
          this.reportSale = d.data.report;
          this.totalOrderPrice = d.data.totalOrderPrice;
          this.totalShippingPrice = d.data.totalShippingPrice;
          var p = this.utilityService;
          if (isPrint)
            setTimeout(function () { p.print(); }, 2000);
        }
        else
          this.toastr.error(d.message);

      }
    )
  }



}



// WEBPACK FOOTER //
// ./src/app/Reports/rpt-shipment/rpt-shipment.component.ts